import React, { useState, useEffect } from 'react';
import { Download, Plus, Share } from 'lucide-react';

const PWAInstallButton = () => {
  const [showButton, setShowButton] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isIOS, setIsIOS] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);

  useEffect(() => {
    // Detect device type
    const userAgent = window.navigator.userAgent.toLowerCase();
    const isIOSDevice = /iphone|ipad|ipod/.test(userAgent);
    
    // Check if already installed (standalone mode)
    const isInStandalone = window.matchMedia('(display-mode: standalone)').matches || 
                          window.navigator.standalone === true;

    setIsIOS(isIOSDevice);
    setIsStandalone(isInStandalone);

    // Don't show if already installed
    if (isInStandalone) {
      return;
    }

    // For iOS - always show the button
    if (isIOSDevice) {
      setShowButton(true);
    }

    // For Android/Chrome - listen for beforeinstallprompt
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowButton(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    if (isIOS) {
      // For iOS, show instructions
      alert(`To install Quick Runner:\n\n1. Tap the Share button (${String.fromCharCode(8593)}) at the bottom\n2. Select "Add to Home Screen"\n3. Tap "Add" to confirm`);
      return;
    }

    if (deferredPrompt) {
      // For Android/Chrome
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      
      if (outcome === 'accepted') {
        console.log('User accepted the install prompt');
        setShowButton(false);
      }
      
      setDeferredPrompt(null);
    }
  };

  if (!showButton || isStandalone) {
    return null;
  }

  return (
    <button
      onClick={handleInstallClick}
      className="fixed bottom-20 right-4 md:bottom-6 md:right-6 z-40 bg-gradient-to-r from-orange-600 to-amber-600 text-white p-3 md:p-4 rounded-full shadow-lg hover:shadow-xl transform transition-all duration-300 hover:scale-110 group"
      aria-label={isIOS ? "Add to Home Screen" : "Install App"}
      title={isIOS ? "Add to Home Screen" : "Install Quick Runner App"}
    >
      {isIOS ? (
        <div className="relative">
          <Plus className="w-5 h-5 md:w-6 md:h-6" />
          <div className="absolute -top-1 -right-1 w-3 h-3 bg-blue-500 rounded-full flex items-center justify-center">
            <Share className="w-2 h-2 text-white" />
          </div>
        </div>
      ) : (
        <Download className="w-5 h-5 md:w-6 md:h-6" />
      )}
      
      {/* Tooltip */}
      <div className="absolute bottom-full right-0 mb-2 px-3 py-1 bg-gray-900 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap pointer-events-none">
        {isIOS ? "Add to Home Screen" : "Install App"}
        <div className="absolute top-full right-3 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900"></div>
      </div>
    </button>
  );
};

export default PWAInstallButton;
